import { type Dispatch, type SetStateAction } from 'react';
import { reconcileHalfDayDates } from '../../lib/projectDetailShared';

function tlDate(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getDate()).padStart(2, '0')} ${['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()]}`;
}

// ── Half-day rates (mockups-feature-builds-2026-07.html §4) — the pure
//    helpers shared by AddCrewBooking, CrewEntryRow's edit mode and the
//    mobile booking sheet now live in lib/projectDetailShared.ts.
//    Re-exported here because ProjectRail.test.tsx imports it from the page.
export { reconcileHalfDayDates };

/** Reconciles half-day selections against a new date range picked from a
    DateField — shared by AddCrewBooking and CrewEntryRow's edit mode. */
function reconcileOnRangeChange(
  setHalfDays: Dispatch<SetStateAction<Set<string>>>,
  start: string | null,
  end: string | null,
) {
  if (!start || !end) return;
  setHalfDays((prev) => {
    const next = reconcileHalfDayDates([...prev], start, end);
    return next.length === prev.size ? prev : new Set(next);
  });
}

export { tlDate, reconcileOnRangeChange };
